import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { AuthContext } from 'core/components/auth';
import { Label } from 'core/components/label';
import LabelWithButton from 'core/components/label-with-button';

import { EditLocationDetailsModal } from './edit-location-details-modal';
import useStyles from './dwelling-address.styles';

const DwellingAddress = ({ dwelling, location, fieldName, includeApt, disabled }) => {
  const classes = useStyles();
  const { canEditHomeAddress } = useContext(AuthContext);
  const [openAddressChangeForm, setOpenAddressChangeForm] = useState(false);

  const address = `${location.address} ${location.address2 ?? ''} ${location.city} ${location.state} ${location.zip}`;

  const AddressComponent = useMemo(() => {
    if (canEditHomeAddress && !disabled) {
      return LabelWithButton;
    }
    return Label;
  }, [canEditHomeAddress]);
  return (
    <>
      {openAddressChangeForm && canEditHomeAddress && (
        <EditLocationDetailsModal
          open={openAddressChangeForm}
          onClose={() => setOpenAddressChangeForm(false)}
          dwelling={dwelling}
          dwellingLocation={location}
          fieldName={fieldName}
          includeApt={includeApt}
        />
      )}
      <div>
        <AddressComponent type="infoSubtitle" onClick={() => setOpenAddressChangeForm(true)}>
          <a
            className={classes.linkAddress}
            href={`https://www.google.com/maps/place/${address}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {address}
          </a>
        </AddressComponent>
      </div>
    </>
  );
};

DwellingAddress.propTypes = {
  dwelling: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  includeApt: PropTypes.bool
};

DwellingAddress.defaultProps = {
  includeApt: false
};

export default DwellingAddress;
